const PREFIX = 'EXTERNAL';

// eslint-disable-next-line import-x/prefer-default-export
export const UNSUSCRIBE_EMAIL = `${PREFIX}/UNSUSCRIBE_EMAIL`;
